
(() => {

const SHIPPING_GOAL = 7500;
const selectedCountry = window.Shopify?.country;

if (selectedCountry !== 'NL') return;


  function formatMoney(cents) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  async function updateShippingBars() {
    const bars = document.querySelectorAll(
      '[data-paw-shipping-bar]'
    );

    if (!bars.length) return;

    try {
      const response = await fetch(
        window.Shopify.routes.root + 'cart.js',
        { cache: 'no-store' }
      );

      if (!response.ok) return;

      const cart = await response.json();
      const amount = cart.total_price;
      const remaining = Math.max(
        0,
        SHIPPING_GOAL - amount
      );

      const progress = Math.min(
        100,
        (amount / SHIPPING_GOAL) * 100
      );

      bars.forEach(bar => {
        const message = bar.querySelector(
          '.paw-shipping-message'
        );

        const progressBar = bar.querySelector(
          '.paw-shipping-progress'
        );

        const labels = bar.querySelectorAll(
          '.paw-shipping-labels span'
        );

        if (message) {
          if (remaining > 0) {
            message.textContent =
              '🤎 Nog ' + formatMoney(remaining) +
              ' tot gratis verzending!';
          } else {
            message.textContent =
              '🤎 Yay! Je hebt gratis verzending!';
          }
        }

        if (progressBar) {
          progressBar.style.width = progress + '%';
        }

        if (labels.length) {
          labels[0].textContent = formatMoney(amount);
        }
      });
    } catch (error) {
      console.error(
        'Verzendbalk kon niet worden bijgewerkt',
        error
      );
    }
  }

  let updateTimer;

  function scheduleUpdate() {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(
      updateShippingBars,
      100
    );
  }

  document.addEventListener(
    'DOMContentLoaded',
    scheduleUpdate
  );

  const observer = new MutationObserver(() => {
    scheduleUpdate();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener(
    'cart:refresh',
    scheduleUpdate
  );
})();
